export const STATE_SETTINGS = {
  jwksState: {
    defaultValue: {},
    key: "EncryptionContext_jwksContext",
  },
  paymentEncryptionJwksKey: {
    defaultValue: {},
    key: "PaymentEncryption_jwksKey",
  },
  timeDifference: {
    default: 0,
    key: "timeDifference",
  },
};
